import { ButtonBS, HStack, Link, LinkProps } from "@biblioteksentralen/react";
import { useState } from "react";
import { DialogLC } from "../components/ModalContainer";
import { useTranslation } from "../utils/hooks/useTranslation";

type Props = {
  heading: string;
  bodyText: string;
  buttonText?: string;
  href?: string;
} & LinkProps;

export const GoToOldMinSideModal = ({ heading, bodyText, buttonText, href, ...linkProps }: Props) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Link as="button" type="button" onClick={() => setOpen(true)} {...linkProps}>
        {heading}
      </Link>
      <DialogLC
        open={open}
        onOpenChange={(e) => setOpen(e.open)}
        placement="center"
        heading={heading}
        footer={
          <HStack alignSelf="flex-end" gap="1rem">
            <ButtonBS variant="secondary" onClick={() => setOpen(false)}>
              {t("Lukk")}
            </ButtonBS>
            {buttonText && (
              <ButtonBS as="a" href={href} target="_blank" alignSelf="flex-end">
                {buttonText}
              </ButtonBS>
            )}
          </HStack>
        }
      >
        {bodyText}
      </DialogLC>
    </>
  );
};
